// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoFeedback_container__3HGVg","star":"VideoFeedback_star__12I0v","input":"VideoFeedback_input__7VSX8","success":"VideoFeedback_success__GsYzX"};